import type { ReactNode } from "react";
import { ColorDot } from "~/components/charts";
import { Text } from "~/components/text";

export interface TotalSalesFooterMarketChipProps {
  market: string;
  className?: string;
  value: ReactNode;
}

/** A single market entry in the Total Sales footer: swatch, code and value. */
export const TotalSalesFooterMarketChip = ({
  market,
  className,
  value,
}: TotalSalesFooterMarketChipProps) => (
  <span className="inline-flex items-center gap-1.5">
    <ColorDot className={className} shape="round" />
    <Text as="span" variant="metric">
      {market}
    </Text>
    <Text as="span" variant="bodyStrong" numeric="tabular">
      {value}
    </Text>
  </span>
);
